<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2022-07-16 11:12:40
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2022-07-17 18:36:19
 * @FilePath: \manger\src\components\Header\MyHeader.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <el-row type="flex" justify="space-between">
      <el-col :span="5">
        <div class="bg-purple"><h1>清元链后台管理</h1></div>
      </el-col>
      <el-col :span="3">
        <el-menu
          :default-active="activeIndex2"
          class="el-menu-demo"
          mode="horizontal"
          background-color="#282929"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <el-menu-item index="3" class="loginOut-btn">
            <el-button type="danger" size="mini" @click="loginOut"
              >退出登录</el-button
            >
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// import Cookies from "js-cookie";
export default {
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "1",
    };
  },
  methods: {
    // handleSelect(key, keyPath) {
    //   console.log(key, keyPath);
    // },
    loginOut() {
      // Cookies.remove("name");
      this.$router.push("/");
    },
  },
};
</script>

<style>
.bg-purple {
  color: rgb(0, 90, 207);
  line-height: 50px;
  font-size: 15px;
}
</style>